import { TRACKING_DOMAINS } from 'define';

export const getHostname = href => {
  try {
    return new URL(href).hostname;
  } catch {
    return '';
  }
};

export const isAbsoluteUrl = href => href.startsWith('https://') || href.startsWith('http://');

export const isOwnDomain = href => TRACKING_DOMAINS.includes(getHostname(href));
